// Deployed default; override with VITE_FITCHECK_API_URL in .env.local to run
// against a local dproz-ai-service.
const FITCHECK_SERVICE_URL =
	import.meta.env.VITE_FITCHECK_API_URL || "https://o2ksqiwued.execute-api.us-east-1.amazonaws.com/dev";

export { FITCHECK_SERVICE_URL };
